import styled from 'styled-components';

export const ContentStyled = styled.div`
  margin: ${props => props.theme.content.margin};
  padding: ${props => props.theme.content.padding};
  width: ${props => props.theme.content.width};
`;



// WEBPACK FOOTER //
// ./styles/components/content.style.js